<template>
  <div class="leifeng-setting">
    <el-card class="main-card">
      <div class="header-section">
        <h2 class="page-title">
          <i class="el-icon-setting title-icon"></i>
          雷锋e站设置管理
        </h2>
      </div>
      
      <div class="content-section">
        <!-- 设置列表 -->
        <div class="table-wrapper">
          <div class="table-container" v-loading="tableLoading">
            <el-table :data="settingList" style="width: 100%" border>
              <el-table-column prop="id" label="ID" width="80"></el-table-column>
              <el-table-column prop="key" label="配置键" min-width="200"></el-table-column>
              <el-table-column prop="value" label="配置值" min-width="120"></el-table-column>
              <el-table-column prop="description" label="说明" min-width="300"></el-table-column>
              <el-table-column prop="create_time_str" label="创建时间" width="180"></el-table-column>
              <el-table-column prop="update_time_str" label="更新时间" width="180"></el-table-column>
              <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" icon="el-icon-edit" @click="openEditDialog(scope.row)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <!-- 空状态 -->
            <div v-if="settingList.length === 0 && !tableLoading" class="empty-state">
              <i class="el-icon-setting empty-icon"></i>
              <p class="empty-text">暂无配置数据</p>
            </div>
            
            <!-- 分页 -->
            <el-pagination
              class="pagination-box"
              :pager-count="7"
              @current-change="pageChange"
              @size-change="sizeChange"
              :page-sizes="[10, 20, 50, 100]"
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="query.limit"
              background
              :total="exp.total"
            />
          </div>
        </div>
      </div>
    </el-card>
    
    <!-- 编辑弹窗 -->
    <el-dialog
      v-dialogDrag
      title="编辑配置"
      :visible.sync="editVisible"
      width="500px"
      class="edit-dialog"
    >
      <el-form :model="editForm" label-width="100px" class="edit-form">
        <el-form-item label="配置键">
          <el-input v-model="editForm.key" disabled></el-input>
        </el-form-item>
        <el-form-item label="配置值">
          <el-input v-model="editForm.value" placeholder="请输入配置值"></el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input v-model="editForm.description" type="textarea" :rows="3" disabled></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="btnLoading" @click="saveSetting">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  settingsList,
  settingsUpdate,
} from '@/api/zhiqing/shop.js'

export default {
  name: 'LeifengSetting',
  data() {
    return {
      tableLoading: false,
      exp: { total: 0 },
      btnLoading: false,
      query: {
        page: 1,
        limit: 20,
      },
      settingList: [],
      editVisible: false,
      editForm: {
        id: '',
        key: '',
        value: '',
        description: '',
      },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.tableLoading = true
      try {
        const { data: res } = await settingsList(this.query)
        console.log('设置列表完整返回:', res)
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.settingList = res.data.list || res.list || []
          this.exp.total = res.data.total || res.total || this.settingList.length
        } else {
          this.$message.error(res.message || '获取设置列表失败')
        }
      } catch (error) {
        console.error('获取设置列表错误:', error)
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.tableLoading = false
      }
    },
    pageChange(page) {
      this.query.page = page
      this.getList()
    },
    sizeChange(size) {
      this.query.limit = size
      this.query.page = 1
      this.getList()
    },
    openEditDialog(row) {
      this.editForm = {
        id: row.id,
        key: row.key,
        value: row.value,
        description: row.description,
      }
      this.editVisible = true
    },
    async saveSetting() {
      if (!this.editForm.value.trim()) {
        this.$message.warning('请输入配置值')
        return
      }
      this.btnLoading = true
      try {
        const { data: res } = await settingsUpdate({
          id: this.editForm.id,
          value: this.editForm.value,
        })
        if (res.code === 200 || res.code === 1 || res.code === 0) {
          this.$message.success('保存成功')
          this.editVisible = false
          this.getList()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.btnLoading = false
      }
    },
  },
}
</script>

<style scoped>
.leifeng-setting {
  padding: 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 120px);
}

.main-card {
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  border: none;
}

.header-section {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f2f5;
}

.page-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.title-icon {
  font-size: 24px;
  color: #409eff;
}

.content-section {
  background: #fff;
}

.table-wrapper {
  background: #fff;
  border-radius: 8px;
}

.table-container {
  padding: 10px 0;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
}

.empty-icon {
  font-size: 64px;
  color: #dcdfe6;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.pagination-box {
  margin-top: 24px;
  text-align: center;
  padding: 10px 0;
}

.edit-dialog {
  border-radius: 8px;
}

.edit-form {
  padding: 10px 0;
}

.dialog-footer {
  text-align: center;
}
</style>